import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule, MatFormFieldModule, MatIconModule, MatInputModule, MatRadioModule, MatToolbarModule } from '@angular/material';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxMaskModule } from 'ngx-mask';
import { FormDetailsComponent } from './form-details.component';


@NgModule({
  entryComponents: [
    FormDetailsComponent
  ],
  declarations: [
    FormDetailsComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    FuseSharedModule,
    MatIconModule,
    PipesModule,
    MatFormFieldModule,
    MatInputModule,
    MatToolbarModule,
    MatRadioModule,
    MatCheckboxModule,
    NgxMaskModule.forRoot(),
    FormsModule
  ],
  exports: [
    FormDetailsComponent
  ]
})
export class FormDetailsModule {
}
